module.exports = __webpack_public_path__ + "media/images/works-show-more-works-arrow-eeb962b33f9e79d924f68281148f4485.svg";